/**
 * The built-in chair (defs/chair.ts) as a data spec: the chair plan symbol
 * (assets/chair.svg) traced into polylines at the default size. The shapes are
 * in one `stretch` group, so the symbol stretches with the footprint along
 * both axes — exactly like the built-in SVG glyph, which is normalized to
 * the footprint box.
 */

import { OBJECT_DEFINITION_SCHEMA_VERSION, type ObjectDefinitionSpec } from 'shared-types';
import chairSvg from '../../assets/chair.svg?raw';
import { svgSymbolShapes } from './svgSymbol';

const W = 0.45;
const D = 0.45;

const shapes = svgSymbolShapes('chair', chairSvg, W, D, 'chair', 'Chair');

export const chairSpec: ObjectDefinitionSpec = {
  schemaVersion: OBJECT_DEFINITION_SCHEMA_VERSION,
  anchor: 'POINT',
  constraint: { kind: 'FREE' },
  defaultSize: { width: W, depth: D, height: 0.9 },
  params: [],
  shapes,
  groups: [{ id: 'symbol', name: 'Chair symbol', shapeIds: shapes.map((s) => s.id), resize: { u: 'stretch', n: 'stretch' } }],
  model3d: null,
};
